import moment from 'moment';
import jwtDecode from 'jwt-decode';

class Jwt {
  constructor(token) {
    this.token = token;
  }

  parse() {
    let payload;
    
    try { payload = jwtDecode(this.token); } catch (e) { 
      this.error = { 
        responseJSON: { error: 'Invalid credentials' }, 
        statusText: 'Unauthorized', 
        status: 401,
        source: e 
      };
    } if (!this.error) {
      this.payload = payload;
      this.expired = moment().isAfter(moment.unix(payload.exp), 'second');  
    }
    
    return this;
  }
}

export default Jwt;
